import React,{Component} from 'react'
import { connect } from "react-redux"
import { bindActionCreators } from "redux";
import Switch from 'react-switchery';
import axios from 'axios'
import * as config from "../../../config"

import * as reportActions from "../../../actions/reportActions"

import "./style.css"
import EditableText from '../../Shared/EditableText'
import SearchInput from '../../Shared/SearchInput'
import Spinner from "../../Shared/Spinner";
import ReportByFile from './ReportByFile'

class Report extends Component{
    constructor(props){
        super(props)

        let id = props.match.params.id;
        let {reportActions} = this.props;

        this.state={
            tempBindingCompanyId:null,
            fetching:false
        }

        if(id !== "0"){
            reportActions.Get(id)
        }
    }
    componentWillUnmount(){
        let {reportActions} = this.props;

        reportActions.Reset()
    }


    handleFieldChange(field,value){
        let {reportActions} = this.props;

        reportActions.ChangeField(field,value);
    }
    handleSettingsChange(field,value){
        let {reportActions} = this.props;
        reportActions.ChangeSettings(field,value);
    }
    handleChangeStartTime(e){
        let value = e.target.value;
        let splitedValue = value.split(":");

        let hour = splitedValue[0];
        let minutes = splitedValue[1];

        if(!hour){
            hour = 0
        }
        if(!minutes){
            minutes = 0
        }

        let{reportActions} = this.props;
        reportActions.ChangeSettings("startHour",hour)
        reportActions.ChangeSettings("startMinute",minutes)
    }
    handleFolderAdd(e){
        e.preventDefault();

        let{report,reportActions} = this.props;

        let {redmineFolders} = report.data.consolidatedReportSettings;

        redmineFolders.push("");

        reportActions.ChangeSettings("redmineFolders",redmineFolders);
    }
    handleFolderDelete(index){
        let{report,reportActions} = this.props;

        let {redmineFolders} = report.data.consolidatedReportSettings;

        redmineFolders.splice(index,1);

        reportActions.ChangeSettings("redmineFolders",redmineFolders);
    }
    handleFolderEdit(e,index){
        let value = e.target.value;

        let{report,reportActions} = this.props;

        let {redmineFolders} = report.data.consolidatedReportSettings;

        redmineFolders[index] = value;

        reportActions.ChangeSettings("redmineFolders",redmineFolders);
    }
    handleAddBinding(obj){
        console.log("obj",obj)
        let{report,reportActions} = this.props;
        let {bindings} = report.data.consolidatedReportSettings;

        let isInArray = false;
        bindings.forEach((elem)=>{
            if(elem.companyId === obj.id){
                isInArray = true
            }
        })

        if(!isInArray){
            bindings.push({
                companyId:obj.id,
                companyName:obj.shownValue
            });
            reportActions.ChangeSettings("bindings",bindings);
        }

    }
    handleCompetitorAdd(e){
        let{report,reportActions} = this.props;
        let {bindings} = report.data.consolidatedReportSettings;

        bindings.push({
            companyId:"",
            companyName:"",
            regions:[]
        });
        reportActions.ChangeSettings("bindings",bindings);
    }
    handleChangeBindingCompany(obj,bindingIndex){
        let{report,reportActions} = this.props;
        let {bindings} = report.data.consolidatedReportSettings;

        bindings[bindingIndex].companyName = obj.shownValue
        bindings[bindingIndex].companyId = obj.id

        reportActions.ChangeSettings("bindings",bindings);
    }
    handleDeleteBinding(index){
        let{report,reportActions} = this.props;
        let {bindings} = report.data.consolidatedReportSettings;

        bindings.splice(index,1);
       // console.log(index)
        reportActions.ChangeSettings("bindings",bindings);

    }
    handleAddBindingRegion(regionId,bindingIndex){
        regionId = parseInt(regionId);
        let{report,reportActions} = this.props;
        let {bindings} = report.data.consolidatedReportSettings;

        if(bindings[bindingIndex].regions.indexOf(regionId) == -1){
            bindings[bindingIndex].regions.push(regionId);
        }


        reportActions.ChangeSettings("bindings",bindings);
    }
    handleDeleteBindingRegion(regionId,bindingIndex){
        regionId = parseInt(regionId);

        let{report,reportActions} = this.props;

        let {bindings} = report.data.consolidatedReportSettings;

        let indexOfRegion = bindings[bindingIndex].regions.indexOf(regionId);

        if(indexOfRegion !== -1){
            bindings[bindingIndex].regions.splice(indexOfRegion,1)
        }

        reportActions.ChangeSettings("bindings",bindings);
    }
    getRegion(regionId){
        let{config} = this.props;
        let result = "";

        if(config.regions != null){
            config.regions.forEach((item)=>{
                if(item.key == regionId){
                    result = item.value;
                }
            })
        }

        return result
    }
    handleSubmit(e){
        let{report,reportActions} = this.props;
        let {data} = report;

        this.setState({
            fetching:true
        })
        axios.post(
            config.apiUrl + "/report/update/",
            data
        )
        .then((response)=>{
            this.setState({
                fetching:false
            })

            this.props.history.push("/admin/reports")
        })
        .catch((err)=>{
            this.setState({
                fetching:false
            })
        })
    }



    render(){
        let {report,config} = this.props
        let {data} = report

        let {consolidatedReportSettings} = data;

        let startHour = consolidatedReportSettings.startHour != null? consolidatedReportSettings.startHour.toString() : "0";
        let startMinute = consolidatedReportSettings.startMinute != null ? consolidatedReportSettings.startMinute.toString() : "0";
        if(startHour.length < 2){
            startHour = "0" + startHour;
        }
        if(startMinute.length < 2){
            startMinute = "0" + startMinute;
        }

        return(
            <React.Fragment>
                <div className="content report-page">
                    <h1 className="report-name">
                        <EditableText
                            value={data.name}
                            placeholder="Введите название отчета"
                            require={true}
                            onSave={(value) =>{
                                this.handleFieldChange("name",value)
                            }}
                        />
                    </h1>

                    <div className="form">
                        <div className="form-body">
                            <div className="switch-wrapp">
                                <Switch
                                    key={data.id}
                                    className="switchery-default"
                                    onChange={(value) => this.handleFieldChange("isActive", value)}

                                    options={
                                        {
                                            color: '#4CAF50',
                                            size: "small"
                                        }
                                    }
                                    checked={data.isActive}
                                />
                                <label>
                                    {
                                        data.isActive?
                                            "Активный"
                                            :
                                            "Неактивный"
                                    }
                                </label>
                            </div>

                            <div className="report-settings">
                                <div className="row">
                                    <div className="col-md-3">
                                        <div className="companies-search">
                                            <label className=" control-label">Основная компания</label>
                                            <SearchInput
                                                className=""
                                                apiUrl="https://api.xmldatafeed.com/companies/all?name="
                                                onObjectChange={(obj) => {
                                                    this.handleSettingsChange("companyId", obj.id)
                                                    this.handleSettingsChange("companyName", obj.shownValue)
                                                    }
                                                }
                                                // outObject={this.state.data.City}
                                                value={consolidatedReportSettings.companyName}
                                                placeholder="Начните вводить название"
                                                mapping={{
                                                    id:"id",
                                                    value:"{name} <br> ({url})",
                                                    shownValue:"{name}",
                                                    dataFieldName:"content.companies"
                                                }}
                                            />
                                        </div>
                                    </div>

                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label>Время старта</label>
                                            <input
                                                type="time"
                                                value={`${startHour }:${startMinute}`}
                                                className="form-control"
                                                onChange={(e)=>this.handleChangeStartTime(e)}
                                            />
                                        </div>
                                    </div>

                                    <div className="col-md-3">
                                        <ReportByFile
                                            ReportId={data.id}
                                        />

                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-3">
                                        <div className="form-group redmine-folders">
                                            <label>Папки в Redmine</label>
                                            {
                                                consolidatedReportSettings.redmineFolders.map((item,index)=>{
                                                    return(

                                                        <div className="input-group folder-item" key={index}>
                                                            <input
                                                                key={index}
                                                                type="text"
                                                                value={item}
                                                                className="form-control"
                                                                onChange={(e)=> this.handleFolderEdit(e,index)}
                                                            />
                                                            <span className="input-group-btn">
                                                                    <button title="Удалить папку" className="btn btn-warning" type="button" onClick={(e)=>{this.handleFolderDelete(index)}}>
                                                                        <i className="glyphicon glyphicon-minus"></i>
                                                                    </button>
                                                                </span>
                                                        </div>
                                                    )
                                                })
                                            }
                                            <div>
                                                <button title="Добавить папку" className="btn btn-success" type="button" onClick={(e)=>this.handleFolderAdd(e)}>
                                                    <i className="glyphicon glyphicon-plus"></i>
                                                </button>

                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label>Конкуренты</label>
                                            {
                                                consolidatedReportSettings.bindings?
                                                    consolidatedReportSettings.bindings.map((item,index)=>{
                                                        return (
                                                            <div className="panel panel-flat" key={index}>
                                                                <div className="panel-heading">
                                                                    <div className="search-group">
                                                                            <SearchInput
                                                                                className=""
                                                                                apiUrl="https://api.xmldatafeed.com/companies/all?name="
                                                                                onObjectChange={(obj) =>
                                                                                    this.handleChangeBindingCompany(obj,index)
                                                                                }
                                                                                // outObject={this.state.data.City}
                                                                                value={item.companyName}
                                                                                placeholder="Начните вводить название"
                                                                                mapping={{
                                                                                    id:"id",
                                                                                    value:"{name} <br> ({url})",
                                                                                    shownValue:"{name}",
                                                                                    dataFieldName:"content.companies"
                                                                                }}
                                                                                clearAfterChoice={false}
                                                                            />

                                                                        <span className="input-group-btn">
                                                                                <button title="Удалить конкурента" className="btn btn-warning" type="button" onClick={(e)=>{this.handleDeleteBinding(index)}}>
                                                                                    <i className="glyphicon glyphicon-minus"></i>
                                                                                </button>
                                                                            </span>
                                                                    </div>
                                                                </div>

                                                                    {
                                                                        item.companyId != ""?
                                                                            <div className="panel-body">
                                                                                {
                                                                                    item.regions.map((regionId)=>{
                                                                                        let region = this.getRegion(regionId)
                                                                                        return(
                                                                                            <span key={regionId} className="ReactTags__tag"  draggable="true">
                                                                                                        {region}
                                                                                                <a className="ReactTags__remove" onClick={()=>this.handleDeleteBindingRegion(regionId,index)}>×</a>
                                                                                                        </span>
                                                                                        )
                                                                                    })
                                                                                }
                                                                                <SearchInput
                                                                                    className=""
                                                                                    //apiUrl="https://api.xmldatafeed.com/companies/all?name="
                                                                                    items ={config.regions}
                                                                                    onObjectChange={(obj) => {
                                                                                        console.log("obj",obj)
                                                                                        this.handleAddBindingRegion(obj.id,index)
                                                                                        }
                                                                                    }
                                                                                    // outObject={this.state.data.City}
                                                                                    //value={consolidatedReportSettings.companyName}
                                                                                    placeholder="Выберите регион и нажмите <Enter>"
                                                                                    mapping={{
                                                                                        id:"key",
                                                                                        value:"{value}"
                                                                                    }}
                                                                                    clearAfterChoice={true}
                                                                                />

                                                                            </div>
                                                                            :null
                                                                    }

                                                            </div>
                                                        )
                                                    })
                                                    :
                                                    null
                                            }

                                            <div>
                                                <button title="Добавить конкурента" className="btn btn-success" type="button"
                                                        onClick={(e)=>this.handleCompetitorAdd(e)}
                                                >
                                                    <i className="glyphicon glyphicon-plus"></i>
                                                </button>

                                            </div>
                                        </div>
                                    </div>


                                </div>

                            </div>
                        </div>

                        <div className=" row form-footer text-left">
                            <button type="submit" className="btn btn-primary" onClick={(e) => this.handleSubmit(e)}>
                                {
                                    this.state.fetching ?
                                        <Spinner />
                                        : <span>Сохранить</span>
                                }
                            </button>
                        </div>
                    </div>
                </div>

            </React.Fragment>
        )
    }
}

function mapStateToProps(state) {
    return {
        report: state.report,
        config: state.config,
    }
}

function mapDispatchToProps(dispath) {
    return {
        reportActions: bindActionCreators(reportActions, dispath),
    }
}

export default connect(mapStateToProps,mapDispatchToProps)(Report);



// WEBPACK FOOTER //
// ./src/components/Admin/Report/index.jsx